// extracted by mini-css-extract-plugin
export var categories = "popularCategoriesStyles-module--categories--732cd";
export var categories_category = "popularCategoriesStyles-module--categories_category--71f25";
export var categories_category_image = "popularCategoriesStyles-module--categories_category_image--54583";
export var categories_category_image_img = "popularCategoriesStyles-module--categories_category_image_img--37eeb";
export var categories_category_title = "popularCategoriesStyles-module--categories_category_title--808f3";
export var container = "popularCategoriesStyles-module--container--73d5e";
export var container_title = "popularCategoriesStyles-module--container_title--93196";
export var pdp = "popularCategoriesStyles-module--pdp--9fd0d";